import { cloneDeep, get } from "lodash-es";

export function isBindEvalString(str = "") {
  return str.includes("bindData.") || str.includes("bindData[");
}

export function getBindDataStringByKey(bindData = {}, key = "") {
  if (!key) {
    return undefined;
  }
  const normalizedKey = key.replace(/^bindData\./, "");
  return get(bindData, normalizedKey);
}

export function replaceBindDataInString(str = "", bindData = {}) {
  if (typeof str !== "string" || !str.includes("${")) {
    return str;
  }

  return str.replace(/\$\{([^}]+)\}/g, (_, expr) => {
    const normalizedExpr = expr.trim().replace(/^bindData\./, "");
    const value = get(bindData, normalizedExpr);
    return typeof value === "undefined" || value === null ? "" : `${value}`;
  });
}

export function shouldUseBindDataValue(value) {
  return (
    typeof value !== "undefined"
    && value !== null
    && (value !== "" || typeof value === "number" || typeof value === "boolean")
  );
}

export function resolveBindDataKeyValue(
  bindData = {},
  bindDataKey = "",
  fallbackValue = "",
) {
  if (!bindDataKey) {
    return fallbackValue;
  }

  if (typeof bindDataKey === "string" && bindDataKey.includes("${")) {
    return replaceBindDataInString(bindDataKey, bindData);
  }

  const bindValue = getBindDataStringByKey(bindData, bindDataKey);
  return shouldUseBindDataValue(bindValue) ? bindValue : fallbackValue;
}

export function cssTextToJsObjWithBindData(cssText = "", bindData = {}) {
  const styleObject = {};

  if (!cssText) {
    return styleObject;
  }

  cssText
    .replace(/;$/g, "")
    .split(";")
    .forEach((item) => {
      const [rawKey, ...rawValueList] = item.split(":");
      const key = rawKey?.trim();
      const value = rawValueList.join(":").trim();

      if (!key || /\s/g.test(key)) {
        return;
      }

      styleObject[key] = replaceBindDataInString(value, bindData);
    });

  return styleObject;
}

export function runBindDataExpression(expression = "", bindData = {}) {
  if (!expression) {
    return undefined;
  }

  try {
    // eslint-disable-next-line no-new-func
    const executor = new Function("bindData", `return (${expression});`);
    return executor(bindData);
  } catch (error) {
    console.log("bindData expression error", error);
    return undefined;
  }
}

export function checkRenderElementShowStatus(
  bindData = {},
  config = {
    bindDataShowKey: "",
    bindDataHideKey: "",
  },
) {
  let result = true;

  if (config.bindDataShowKey) {
    if (!isBindEvalString(config.bindDataShowKey)) {
      const showValue = getBindDataStringByKey(bindData, config.bindDataShowKey);
      if (typeof showValue !== "undefined") {
        result = !!showValue;
      }
    } else {
      const showValue = runBindDataExpression(config.bindDataShowKey, bindData);
      if (typeof showValue !== "undefined") {
        result = !!showValue;
      }
    }
  } else if (config.bindDataHideKey) {
    if (!isBindEvalString(config.bindDataHideKey)) {
      const hideValue = getBindDataStringByKey(bindData, config.bindDataHideKey);
      if (typeof hideValue !== "undefined") {
        result = !hideValue;
      }
    } else {
      const hideValue = runBindDataExpression(config.bindDataHideKey, bindData);
      if (typeof hideValue !== "undefined") {
        result = !hideValue;
      }
    }
  }

  return result;
}

export function filterConfigByScript(scriptStr = "", bindData = {}, config = {}) {
  const nextConfig = cloneDeep(config);

  if (!scriptStr) {
    return nextConfig;
  }

  try {
    // eslint-disable-next-line no-new-func
    const executor = new Function(
      "bindData",
      "config",
      `${scriptStr}\nreturn config;`,
    );
    return executor(bindData, nextConfig) || nextConfig;
  } catch (error) {
    console.log("filterScript error", error);
    return nextConfig;
  }
}
